import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { Card } from "@/components/ui/card";

export default function YouTubeCallback() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Give the backend time to process the callback
    // then redirect back to profile
    const timer = setTimeout(() => {
      setLocation('/profile');
    }, 2000);

    return () => clearTimeout(timer);
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="p-6">
        <h2 className="text-xl font-semibold mb-2">Verifying YouTube Membership</h2>
        <p className="text-muted-foreground">Please wait while we verify your membership status...</p>
      </Card>
    </div>
  );
}
